import 'swiper/swiper-bundle.css'
import '../scss/widget-avaliacao.scss'

import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Autoplay } from 'swiper/modules'
import type { AvaliacaoApp } from '../avaliacao-app.props'

export function WidgetAvaliacao({avaliacoes, titulo}: Readonly<AvaliacaoApp>) {
    if (!avaliacoes) return null

    const getRatingAvaliacao = (nota: number, size = '23px', classe = 'star-back') => {
        const width = (nota / 5) * 100

        size = size === 'small' ? '23px' : size
        size = size === 'big' ? '26px' : size

        let title
        if (!nota) {
            title = 'Nenhuma avaliação'
        } else {
            title = nota + ' de 5'
        }

        const spanElement = (
            <span
                className={`average-rating cursor-pointer ${classe}`}
                data-value={nota}
                title={title}
                style={{ '--size': size, '--percent': `${width}%` } as React.CSSProperties}
            />
        )

        return spanElement
    }

    return (
        <div className="widget-avaliacao">
            <div className="container">
                {titulo && (
                    <div className="title-ctn">
                        <h2 className="bg-title">
                            <span>{titulo}</span>
                        </h2>
                    </div>

                )}
               <div className="avaliacoes-carousel">
                    <Swiper
                        modules={[Navigation, Autoplay]}
                        slidesPerView={1}
                        navigation={{
                            nextEl: '.widget-avaliacao .swiper-button-next',
                            prevEl: '.widget-avaliacao .swiper-button-prev'
                        }}
                        autoplay={{
                            delay: 5000,
                            disableOnInteraction: false
                        }}
                        rewind
                        breakpoints={{
                            0: { slidesPerView: 1 },
                            520: { slidesPerView: 2 },
                            700: { slidesPerView: 3 },
                            1100: { slidesPerView: 4 }
                        }}
                    >
                        {avaliacoes.map((item, index) => (
                            <SwiperSlide key={index}>
                                <div className="avaliacoes-carousel-each">
                                    <div className="autor">{item.cliente}</div>

                                    <div className="data">Data da avaliação: {item.data}</div>

                                    {item.cidade && (
                                        <div className="local">
                                        {item.cidade} - {item.estado}
                                        </div>
                                    )}

                                    <div className="titulo">{item.titulo}</div>

                                    <div className="nota">
                                        {getRatingAvaliacao(item.nota, 'big')}
                                    </div>

                                    <div className="mensagem">{item.mensagem}</div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>

                    <div className="swiper-button-prev"></div>
                    <div className="swiper-button-next"></div>
                </div>
            </div>
        </div>
    )
}